export const environment = {
  production: true,

  apiBaseUrl: 'https://bot.aliceblueonline.com/api/v2',
  riseapi: 'https://mfrisego.aliceblueonline.com',

  antRedirect: 'https://ant.aliceblueonline.com/?appcode=mGy0mgshPXddK61',

  pathUrl: 'https://bot.aliceblueonline.com/#/',
  ImgUrl: 'https://bot.aliceblueonline.com/',
};
